"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.expandGroup = exports.expandBackreference = void 0;
var Expansion_1 = __importDefault(require("../Expansion"));
var Guards = __importStar(require("../types/regexp-tree-guards"));
/* istanbul ignore next */
function assertNever(x) {
    throw new Error("Unexpected backreference: " + x);
}
var namedGroups = {};
var numberedGroups = {};
/**
 * Expand an expression which copies a Group elsewhere in
 * the regular expression, either by number or name.
 * @param node The Backreference expression to expand
 * @return The Expansion of node
 */
function expandBackreference(node) {
    var lookupBackreference = function () { return []; };
    if (Guards.isNamedBackreference(node)) {
        lookupBackreference = function () { return [namedGroups[node.reference]]; };
    }
    else if (Guards.isNumericBackreference(node)) {
        lookupBackreference = function () { return [numberedGroups[node.number]]; };
    }
    else {
        /* istanbul ignore next */
        assertNever(node);
    }
    return new Expansion_1["default"](lookupBackreference, 1);
}
exports.expandBackreference = expandBackreference;
/**
 * Expand an expression that wraps another expression, like "(a)"
 * and "(\d+|[a-d])". If the outer expression is "capturing", it has
 * an implicit numeric identifier and can have an explicit name.
 * @param node The Group expression to expand
 * @return The Expansion of node
 */
function expandGroup(node) {
    var generator = this.expandExpression(node.expression);
    function expandAndStoreCapture(expression) {
        // Store the expansion in case this Group is referenced
        // by a Backreference.
        if (Guards.isCapturingGroup(node)) {
            numberedGroups[node.number] = expression;
            if (node.name) {
                namedGroups[node.name] = expression;
            }
        }
        return expression;
    }
    function expandAndStoreCaptures() {
        var _a, _b, expression, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values(generator.getIterator()), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done) return [3 /*break*/, 4];
                    expression = _b.value;
                    return [4 /*yield*/, expandAndStoreCapture(expression)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a["return"])) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }
    return new Expansion_1["default"](expandAndStoreCaptures, generator.count);
}
exports.expandGroup = expandGroup;
//# sourceMappingURL=group-pattern.js.map